import { useNavigate } from 'react-router-dom'
import { colors } from 'utils/colors'

import Pulse from '../Pulse'
import { Container } from '../shared/style'
import { getLeadRoute } from 'utils/url'

interface Props {
  leadId: string
  leadAppointmentId: string
}

const MeetingStatus: React.FC<Props> = ({ leadId, leadAppointmentId }) => {
  const navigate = useNavigate()

  const handleClickDetail = () => {
    navigate(`${getLeadRoute({ leadId })}?window=activities-tab&window_type=meeting&meeting_id=${leadAppointmentId}`)
  }

  return (
    <Container onClick={handleClickDetail} backgroundColor={colors.purple1}>
      <Pulse />
      In meeting...
    </Container>
  )
}

export default MeetingStatus
